import { render, staticRenderFns } from "./UpdatePopup.vue?vue&type=template&id=2f3d9264&scoped=true&"
import script from "./UpdatePopup.vue?vue&type=script&lang=js&"
export * from "./UpdatePopup.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePopup.vue?vue&type=style&index=0&id=2f3d9264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d9264",
  null
  
)

export default component.exports